    <div class="container">
        <h1>Användarvillkor för Fototävling</h1>
        <p class="updated"><strong>Senast uppdaterad:</strong> 1 oktober 2025</p>

        <h2>1. Acceptans av villkor</h2>
        <p>Genom att använda Fototävling accepterar du dessa villkor. Om du inte accepterar villkoren, använd inte applikationen.</p>

        <h2>2. Behörighet</h2>
        <p>Du måste:</p>
        <ul>
            <li>Ha ett aktivt Facebook-konto</li>
            <li>Vara minst 13 år gammal</li>
            <li>Följa Facebook:s användarvillkor</li>
        </ul>

        <h2>3. Ditt innehåll</h2>
        <p>Du behåller rättigheterna till dina bilder, men ger oss rätt att visa dem i applikationen och använda dem för marknadsföring. Du garanterar att:</p>
        <ul>
            <li>Du äger materialet eller har rätt att dela det</li>
            <li>Innehållet inte kränker andras rättigheter</li>
            <li>Innehållet inte är olagligt, stötande eller hatiskt</li>
        </ul>

        <h2>4. Förbjuden användning</h2>
        <p>Du får inte:</p>
        <ul>
            <li>Ladda upp innehåll du inte har rätt till</li>
            <li>Manipulera röstning eller använda bots</li>
            <li>Trakassera andra användare</li>
            <li>Försöka få obehörig åtkomst till systemet</li>
        </ul>

        <h2>5. Tävlingsregler</h2>
        <ul>
            <li>Varje tävling har egna regler som måste följas</li>
            <li>Röstningsmanipulation leder till diskvalificering</li>
            <li>Tävlingsarrangörer ansvarar för sina tävlingar och priser</li>
        </ul>

        <h2>6. Moderering</h2>
        <p>Vi kan ta bort innehåll och stänga av konton som bryter mot dessa villkor utan förvarning.</p>

        <h2>7. Ansvarsbegränsning</h2>
        <p>Applikationen tillhandahålls "som den är". Vi ansvarar inte för:</p>
        <ul>
            <li>Tekniska fel eller avbrott</li>
            <li>Förlust av data</li>
            <li>Innehåll som användare laddar upp</li>
            <li>Indirekta skador</li>
        </ul>

        <h2>8. Personuppgifter</h2>
        <p>Vi hanterar dina personuppgifter enligt vår Integritetspolicy och GDPR.</p>

        <h2>9. Ändringar</h2>
        <p>Vi kan ändra dessa villkor när som helst. Fortsatt användning innebär att du accepterar ändringarna.</p>

        <h2>10. Uppsägning</h2>
        <p>Vi kan stänga av din åtkomst vid brott mot villkoren. Du kan när som helst sluta använda applikationen.</p>

        <h2>11. Tillämplig lag</h2>
        <p>Dessa villkor regleras av svensk lag.</p>

        <h2>12. Kontakt</h2>
        <div class="contact">
            <p>För frågor, kontakta oss på:</p>
            <ul>
                <li><strong>E-post:</strong> erik at kvarnbrannaby punkt se</li>
            </ul>
        </div>

        <div class="footer">
            <p>Genom att använda Fototävling accepterar du dessa villkor.</p>
        </div>
    </div>
